import { configureStore } from '@reduxjs/toolkit'
import { apiKeysReducer } from '../modules/admin/slices/api-keys.slice'
import { billingReducer } from '../modules/admin/slices/billing.slice'
import { businessesReducer } from '../modules/admin/slices/businesses.slice'
import { clientPolicyReducer } from '../modules/admin/slices/client-policy.slice'
import { creativesReducer } from '../modules/admin/slices/creatives.slice'
import { devicesReducer } from '../modules/admin/slices/devices.slice'
import { userActivityReducer } from '../modules/admin/slices/user-activity.slice'
import { usersReducer } from '../modules/admin/slices/users.slice'
import { authenticationViewReducer } from '../modules/authentication/slices/authentication-view.slice'
import { userEntitiesReducer } from '../modules/authentication/slices/user-entities.slice'

export const store = configureStore({
  reducer: {
    authenticationView: authenticationViewReducer,
    userEntities: userEntitiesReducer,
    allUsers: usersReducer,
    apiKeys: apiKeysReducer,
    billing: billingReducer,
    businesses: businessesReducer,
    clientPolicy: clientPolicyReducer,
    creatives: creativesReducer,
    devices: devicesReducer,
    userActivity: userActivityReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
})

window.globalStore = store

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
